<template>
  <div class="admin-wrapper" :class="{ 'mobile-sidebar-open': appStore.isMobileSidebarOpen }">
    <!-- Backdrop overlay for mobile drawer -->
    <transition name="fade">
      <div
        v-if="appStore.isMobileSidebarOpen"
        class="sidebar-backdrop"
        @click="appStore.closeMobileSidebar"
      ></div>
    </transition>

    <Sidebar />
    <div class="admin-main">
      <Topbar />
      <main class="admin-content">
        <router-view :key="$route.fullPath" />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import Sidebar from './components/Sidebar.vue'
import Topbar from './components/Topbar.vue'
import { useAppStore } from '@/stores/app'

const appStore = useAppStore()
</script>
